import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { lighten, useTheme } from '@mui/material/styles'
import { FormSectionProps } from '../../interfaces/form'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'

import FormWizard from '../wizard'
import FormCheck from '../../components/FormCheck'

const radioStyle = {
  paddingBottom: 0,
  display: 'none',
}

const radioOverrideMuiStyle = {
  '&.MuiCheckbox-root': {
    '&.Mui-checked + span': {
      backgroundColor: `primary.main`,
      color: '#FFF !important',
    },
  },
}

const textStyle = {
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: '4px',
  display: 'inline-flex',
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: 'primary.main',
  marginTop: 0,
  marginRight: '6px',
  marginBottom: '10px',
  fontWeight: 'bold',
  verticalAlign: 'top',
  width: '100%',
  height: '100%',
  minHeight: 80,
  cursor: 'pointer',
}

const Policies = ({ validate }: FormSectionProps) => {
  const theme = useTheme()

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        <FormWizard.Page validate={validate}>
          <Typography variant="h3" sx={{ mb: 4 }}>
            Outside of work, do you currently have any of these policies in
            place?
          </Typography>
          <Typography variant="body1" sx={{ mb: 8 }}>
            Select all that apply.
          </Typography>
          <Grid container spacing={2} sx={{ mb: 14 }}>
            <Grid item xs={12} md={6}>
              <label htmlFor="life-insurance" style={{ textAlign: 'center' }}>
                <FormCheck
                  id="life-insurance"
                  name="policies"
                  value="Life Insurance"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Life Insurance
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label
                htmlFor="income-protection"
                style={{ textAlign: 'center' }}
              >
                <FormCheck
                  id="income-protection"
                  name="policies"
                  value="Income Protection"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Income Protection
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label htmlFor="critical-illness" style={{ textAlign: 'center' }}>
                <FormCheck
                  id="critical-illness"
                  name="policies"
                  value="Critial Illness"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Critial Illness
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label
                htmlFor="family-income-benefit"
                style={{ textAlign: 'center' }}
              >
                <FormCheck
                  id="family-income-benefit"
                  name="policies"
                  value="Family Income Benefit"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Family Income Benefit
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label htmlFor="none" style={{ textAlign: 'center' }}>
                <FormCheck
                  id="none"
                  name="policies"
                  value="None"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  None
                </Typography>
              </label>
            </Grid>
            <Grid item xs={12} md={6}>
              <label htmlFor="not-sure" style={{ textAlign: 'center' }}>
                <FormCheck
                  id="not-sure"
                  name="policies"
                  value="Not sure"
                  style={radioStyle}
                  overrideMuiStyle={radioOverrideMuiStyle}
                />
                <Typography
                  component="span"
                  sx={{
                    ...textStyle,
                    backgroundColor: lighten(theme.palette.primary.main, 0.8),
                  }}
                >
                  Not sure
                </Typography>
              </label>
            </Grid>
          </Grid>
        </FormWizard.Page>
      </Box>
    </Container>
  )
}

export default Policies
